import React, { useState } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { TextField } from '@mui/material';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const EMPTY_FORM = { phoneNumber: '', nickName: '', terminationUri: '', trunkUsername: '', trunkPassword: '' };

const AddPhoneModal = ({ isOpen, onClose, onSave, salesAccountId }) => {
    const [form, setForm] = useState(EMPTY_FORM);
    const update = (key, value) => setForm(prev => ({ ...prev, [key]: value }));

    const handleSave = () => {
        onSave(salesAccountId ? { ...form, salesAccountId } : form);
        setForm(EMPTY_FORM);
    };

    const handleClose = () => {
        setForm(EMPTY_FORM);
        onClose();
    };

    return (
        <Modal isOpen={isOpen} toggle={handleClose} className="main-modal new-user-modal modal-dialog-centered create-label-modal">
            <ModalHeader toggle={handleClose}></ModalHeader>
            <ModalBody>
                <div className="content-area">
                    <h4>Connect your number via SIP trunking</h4>
                    <div className="form-area">
                        <div className="group-form phone-group">
                            <label>Phone Number</label>
                            <PhoneInput
                                country="us"
                                onlyCountries={['us']}
                                countryCodeEditable={false}
                                placeholder="Enter Phone Number"
                                specialLabel=""
                                value={form['phoneNumber'] || ''}
                                onChange={value => update('phoneNumber', `+${value}`)}
                            />
                        </div>
                        <div className="group-form">
                            <label>Nickname <span>(Optional)</span></label>
                            <TextField fullWidth size="small" variant="standard" placeholder="Enter Nickname" value={form['nickName'] || ''} onChange={e => update('nickName', e['target']['value'])} style={{ backgroundColor: 'white' }} />
                        </div>
                        <div className="group-form">
                            <label>Termination URI</label>
                            <TextField required fullWidth size="small" variant="standard" placeholder="Enter Termination URI" value={form['terminationUri'] || ''} onChange={e => update('terminationUri', e['target']['value'])} style={{ backgroundColor: 'white' }} />
                        </div>
                        <div className="group-form">
                            <label>SIP Trunk User Name <span>(Optional)</span></label>
                            <TextField fullWidth size="small" variant="standard" placeholder="Enter SIP Trunk User Name" value={form['trunkUsername'] || ''} onChange={e => update('trunkUsername', e['target']['value'])} style={{ backgroundColor: 'white' }} />
                        </div>
                        <div className="group-form">
                            <label>SIP Trunk Password <span>(Optional)</span></label>
                            <TextField fullWidth size="small" variant="standard" placeholder="Enter SIP Trunk Password" value={form['trunkPassword'] || ''} onChange={e => update('trunkPassword', e['target']['value'])} style={{ backgroundColor: 'white' }} />
                        </div>
                        <div className="alert alert-warning alert-docs-phone" role="alert">
                            Need help filling out these fields? <a href="https://docs.sellagent.ai/pages/twilio-sip-trunk" target="_blank" rel="noopener noreferrer">Open docs</a>
                        </div>
                        <div className="btns-box text-right">
                            <button className="btn-style-border" onClick={handleClose}>Cancel</button>
                            <button className="btn-style-new" onClick={handleSave}>Save</button>
                        </div>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default AddPhoneModal;
